/**
 * Portfolio component
 *
 * Highlights some of  your creations. These can be designs, websites,
 * open source contributions, articles you've written and more.
 *
 * This is a great area for you to to continually add to and refine
 * as you continue to learn and create.
 */

import React from "react";

/**
 * Desk image
 *
 * Below is a sample desk image. Feel free to update this to an image of your choice,
 * updating below imageAltText to string that represents what you see in that image.
 *
 * Need an image? Check out https://unsplash.com to download a photo you
 * freely use on your site.
 */
import image from "../images/wh.jpg";

const imageAltText = "A computer monitor showing bold text stating 'work hard'";

/**
 * Project list
 *
 * An array of objects that will be used to display for your project
 * links section. Below is a sample, update to reflect links you'd like to highlight.
 */
const projectList = [
  {
    title: "The Pine City Zoo",
    description:
      "A friendly application for kids. This project showcases a fun and interactive zoo experience, allowing children to learn about animals through engaging activities.",
    url: "https://pine-zoo.netlify.app/",
  },
  {
    title: "E-Train",
    description:
      "This website is an interactive program for education. It provides online education resources and activities to support learning from pre school to grade 7.",
    url: "https://e-train.netlify.app/",
  },
  {
    title: "Previous Portfolio",
    description:
      "Created as part of hackathon in PLP Africa Academy. The website lacks sematics and web design.",
    url: "https://starhluga-portfolio.netlify.app/",
  },
  {
    title: "Siwe's Beauty Parlour",
    description:
      "I contributed to the creation of the Salon website. The Siwe's beauty parlour is a website assignment showcasing a beauty salon's services and booking system. I played a part in collaborating with other developers to bring this project to life.",
    url: "https://siwes-beauty-parlour.netlify.app/",
  },
];

const Portfolio = () => {
  return (
    <section className="padding" id="portfolio">
      <h2 style={{ textAlign: "center" }}>Projects</h2>
      <div style={{ display: "flex", flexDirection: "row", paddingTop: "3rem" }}>
        <div style={{ maxWidth: "40%", alignSelf: "center" }}>
          <img
            src={image}
            style={{ height: "90%", width: "100%", objectFit: "cover" }}
            alt={imageAltText}
          />
        </div>
        <div className="container">
          {projectList.map((project) => (
            <div className="box" key={project.title}>
              <a href={project.url} target="_blank" rel="noopener noreferrer">
                <h3 style={{ flexBasis: "40px" }}>{project.title}</h3>
              </a>
              <p className="small">{project.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
